import { useLayoutEffect, useMemo, useRef } from 'react'

/** Track initialization and reject queued events from inactive layouts. */
export const useColumnStateLifecycle = (contextKey: string | null) => {
  const activeLifecycleRef = useRef<object | null>(null)
  const lifecycle = useMemo(() => {
    const activation = {
      contextKey,
      initialized: false,
      pendingInitialAutoSize: false,
      isActive: (): boolean => activeLifecycleRef.current === activation,
    }
    return activation
  }, [contextKey])

  // Register the committed activation for the external grid's callbacks.
  // Cleanup invalidates queued callbacks on replacement and unmount, without
  // publishing a speculative render's activation to the currently mounted grid.
  useLayoutEffect(() => {
    activeLifecycleRef.current = lifecycle
    return () => {
      activeLifecycleRef.current = null
    }
  }, [lifecycle])

  return lifecycle
}
